import http from '@http';

class StorageService {
    getAll() {
        return http.get('/api/classifiers/storages').then((res) => res.data);
    }
}

export const storageService = new StorageService();
